var map = {
	"./blood_pressure.png": 98153,
	"./blood_sugar.png": 72656,
	"./bowel.png": 85264,
	"./chest_pain.png": 32465,
	"./dizziness.png": 79596,
	"./exercise.png": 22929,
	"./eye_pain.png": 6945,
	"./food.png": 98219,
	"./heart_rate.png": 97974,
	"./mindfulness.png": 43851,
	"./physical-activity.png": 52968,
	"./stress.png": 46387,
	"./temperature.png": 87417,
	"./tightness.png": 25874,
	"./water.png": 41866,
	"./weight.png": 30775,
	"./yoga.png": 44055
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70151;